import SPIN from './model';
import create from './create';
import * as _actions from './actions';
import _reducer from './reducer';

SPIN.create = create;

export default SPIN;
export const actions = _actions;
export const reducer = _reducer;



// WEBPACK FOOTER //
// ./data/WritingAssignment/SPIN/index.js